import { useState } from 'react'
import Feather from '@sysunite/react-feather'
import { LogoMain } from 'wvrio-styleguide'
import { Button, Card, Modal, Tooltip } from 'antd'
import './SupportButton.scss'

export default SupportButton = ({ collapsed, style }) ->

  [visible, setVisible] = useState(false)

  <>
    <Tooltip
      placement="right"
      title="Support"
    >
      <Button
        data-testid="support-button"
        type="text"
        style={{ margin: '8px 0px' }}
        onClick={-> setVisible(true)}
        icon={<span className="anticon"><Feather type='message-square' /></span>}
      >
        { "Support" unless collapsed }
      </Button>
    </Tooltip>

    <Modal
      visible={visible}
      onCancel={-> setVisible(false)}
      centered={true}
      footer={<div />}
      width={Math.max(800, window.innerWidth / 2)}
      title="Weaver Support"
      style={
        marginTop: '3vh'
      }
      bodyStyle={{
        maxHeight: '82vh'
        overflow: 'auto'
      }}
      className="support"
    >
    <Card
      bordered={false}
      style={{
        position: 'relative'
        width: '100%',
        borderRadius: 5
        boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.06)'
        textAlign: 'center'
      }}
      headStyle={{
        border: 'none'
      }}
    >
      <LogoMain style={{ width: 200, margin: '30px auto'}}/>
      <div>
        <p>If you are having trouble, please take a look at our <a href="https://support.weaverhq.com/">guides.</a></p>
        <p>For any support questions, you can email us at <b>support@weaverhq.com</b>.</p>
        <p>You are also invited to join our discord community, which can be found <a href="https://discord.gg/NPaUhvytuD">here</a>.</p>
      </div>
    </Card>
    </Modal>
  </>
